const PromotionType = {
  PRODUCT: "product",
  COUPON: "coupon"
};
var OrderBy = /* @__PURE__ */ ((OrderBy2) => {
  OrderBy2["ASC"] = "ASC";
  OrderBy2["DESC"] = "DESC";
  return OrderBy2;
})(OrderBy || {});

export { OrderBy, PromotionType };
